export var defaultProps = {
  color: 'black',
  size: 'sm'
};